module.exports = __webpack_public_path__ + "img/f-thermometer-img4-2.37cc6cb5.png";